import { RoutePath } from '@shared/constants/routing.constants.tsx';

export const PathNavigator = {
  home: RoutePath.Base,
  getEVSEDetailsPath: (cpid: string) => `${RoutePath.EVSEDetailsBase}/${cpid}`,
  login: RoutePath.Login,
};
